import { createStore } from 'satcheljs';
import type { AppHostSearchStore } from './schema/AppHostSearchStore';
import type { SearchServiceEventMap } from '@metaos/hub-sdk';

const store = createStore<AppHostSearchStore>('AppHostSearchStore', {
    isSearchEnabled: false,
    eventRegistrationsMap: new Map<keyof SearchServiceEventMap, (event: any) => void>(),
})();
export default () => store;
